import { Trans } from '@lingui/react/macro';

import { LoadingAnimation } from '../../../common-components/animations/loading/LoadingAnimation';

const LoadingNoteGeneration = () => {
  const messages = [
    <Trans>Generating Audio Transcript...</Trans>,
    <Trans>Generating Summary...</Trans>,
    <Trans>Generating Clinical Note...</Trans>,
  ];

  return (
    <>
      <div className="vai-flex vai-flex-col vai-items-center">
        <LoadingAnimation translatedMessages={messages} />
      </div>
    </>
  );
};

export default LoadingNoteGeneration;
